import styled from 'styled-components';

export const SCRoutesWrapper = styled.main`
    width: 100%;
    height: auto;
    padding: 0;
    background-color: rgba(255, 255, 255, 1);
`;
